type Observation = {
  id?: unknown;
  status?: unknown;
  lease_generation?: unknown;
};

export function isStaleScanObservation(previous: Observation | null, next: Observation): boolean {
  if (!previous || previous.id !== next.id) return false;
  if (typeof previous.lease_generation === "number"
    && (typeof next.lease_generation !== "number" || next.lease_generation < previous.lease_generation)) {
    return true;
  }
  return ["FAILED", "COMPLETED", "CANCELED"].includes(String(previous.status))
    && previous.status !== next.status;
}
